export enum PointSubtype {
  UNKNOWN = 0,
  OBJECT = 1,
  MANHOLE = 3,
  CUSTOM = 4,
}
